import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogDetailRoutingModule } from './blog-detail-routing.module';
import { BlogDetailComponent } from './blog-detail.component';
import {GALLERY_CONFIG, GalleryComponent, GalleryConfig} from "ng-gallery";
// import { NgxGalleryModule } from '@vinlos/ngx-gallery';

@NgModule({
  declarations: [ BlogDetailComponent ],
  imports: [
    CommonModule,
    BlogDetailRoutingModule,
    GalleryComponent,
  ],
  providers: [
    {
      provide: GALLERY_CONFIG,
      useValue: {
        autoHeight: true,
        imageSize: 'cover'
      } as GalleryConfig
    }
  ]
})
export class BlogDetailModule {
}
